import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#586D89", d: "M15 5.875 14.125 5 10 9.125 5.875 5 5 5.875 9.125 10 5 14.125l.875.875L10 10.875 14.125 15l.875-.875L10.875 10 15 5.875z" }));
const ForwardRef = forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
